import Subject from "../cse4sub/Subject";
import React from 'react'
import csm from '../assets/AE402mid21.pdf'

export default function Sl() {
  return (
    <div>
       <Subject title="Surveying & Leaveling(AE402)" book1=" " book2=" "mid="Q. Paper"
    book1Link="#" book2Link="#" int21="#" mid21={csm} end21="#"
     int20="#" mid20="#" end20="#"
    />
    </div>
  )
}